<div class="notification-preferences">
  <div class="notification-preferences__header">
    <p class="notification-preferences__description">{{ 'notifications.preferences.description' | translate }}</p>
  </div>

  @if (isLoading()) {
    <div class="notification-preferences__loading" role="status">
      <span zagIcon="hourglass_empty" class="notification-preferences__loading-icon"></span>
      <span>{{ 'common.loading' | translate }}</span>
    </div>
  } @else if (hasError()) {
    <div class="notification-preferences__error" role="alert">
      <span zagIcon="error_outline" class="notification-preferences__error-icon"></span>
      <span>{{ 'notifications.preferences.loadError' | translate }}</span>
      <button type="button" class="notification-preferences__retry-btn" (click)="retryLoad()">
        {{ 'common.retry' | translate }}
      </button>
    </div>
  } @else {
    <!-- Event type list with toggles -->
    <ul class="notification-preferences__list" role="list">
      @for (eventType of eventTypes; track eventType) {
        <li class="notification-preferences__item">
          <span class="notification-preferences__event-label">{{ 'notifications.eventTypes.' + eventType | translate }}</span>
          <button
            type="button"
            class="notification-preferences__toggle"
            [class.notification-preferences__toggle--on]="isEnabled(eventType)"
            [attr.aria-label]="'notifications.eventTypes.' + eventType | translate"
            [attr.aria-checked]="isEnabled(eventType)"
            [disabled]="!canManage()"
            role="switch"
            (click)="togglePreference(eventType)"
          >
            <span class="notification-preferences__toggle-thumb"></span>
          </button>
        </li>
      }
    </ul>
  }
</div>
